import '@learnforge/demo-kit/styles.css';
import '@learnforge/demo-kit/shell.css';
import '@learnforge/demo-render/styles.css';
import './styles.css';

import { bootstrapDemoShell } from '@learnforge/demo-kit';
import { makePrng } from '@learnforge/demo-math/numeric';
import { EXPERIMENTS } from './experiments';
import { i18n } from './i18n';
import type { AlgebraContext, ExperimentKey } from './types';

const ORDER = Object.keys(EXPERIMENTS) as ExperimentKey[];
const params = new URLSearchParams(window.location.search);

bootstrapDemoShell({
  slug: 'algebra',
  i18n,
  experiments: EXPERIMENTS,
  order: ORDER,
  eyebrowKey: 'app.eyebrow',
  helpLineKeys: ['hint.line1', 'hint.line2'],
  shotToExperiment: (id) => (ORDER.includes(id as ExperimentKey) ? (id as ExperimentKey) : null),
  extendContext: (base, { shotId }): AlgebraContext => {
    const seedParam = params.get('seed');
    return {
      ...base,
      prng: makePrng(shotId !== null ? 42 : seedParam ? Number(seedParam) : 1),
    };
  },
});
